import { Chain, ChainID, ChainSubType } from '@ankr.com/chains-list';
import { useEffect, useState } from 'react';

interface UseChainSubtypeProps {
  chain: Chain;
}

const getInitialChainSubtype = (chain: Chain) =>
  chain.id === ChainID.ZETACHAIN ? ChainSubType.Athens3 : undefined;

export const useChainSubType = ({ chain }: UseChainSubtypeProps) => {
  const [chainSubType, setChainSubType] = useState(
    getInitialChainSubtype(chain),
  );

  useEffect(() => {
    setChainSubType(getInitialChainSubtype(chain));
  }, [chain]);

  return { chainSubType, setChainSubType };
};
